import SVGInjector from './svg-injector';
export default SVGInjector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tanem/svg-injector/esm/index.js
// module id = 350
// module chunks = 0